<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div class="min-h-screen flex items-center container mx-auto">
            <div class="mx-auto w-full md:w-3/4 lg:w-1/3">
                <h1 class="text-7xl font-bold">
                    {{ $t('404') }}
                </h1>

                <p>
                    {{ $t('Page not Found') }}
                </p>

                <FormButton type="submit" class="my-6" styling="primary flex items-center gap-3" :value="$t('Back')" @click="$router.go(-1)"> </FormButton>
            </div>
        </div>
    </transition>
</template>

<script>
export default {};
</script>
